/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  LoginResponse,
  LogoutResponse,
  GenericErrorResponse,
  UserResponse,
  SocialLoginResponse,
  ApiResponse,
} from './responses';

import {
  AccountSignupPayload,
  LoginPayload,
  LogoutPayload,
  SocialLoginPayload,
} from './requests';
import { ContentType, HttpClient, RequestParams } from './httpClient';

export class Auth<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Auth
   * @name signOut
   * @request POST:/users/logout
   * @response `200` `ApiResponse` Success
   */
  signOut = (data: LogoutPayload, params: RequestParams = {}) =>
    this.request<LogoutResponse, GenericErrorResponse>({
      path: '/users/logout',
      method: 'POST',
      body: data,
      format: 'json',
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Auth
   * @name socialSignIn
   * @request POST:/auth/social/login
   * @response `200` `ApiResponse` Success
   */
  socialSignIn = (body: SocialLoginPayload, params: RequestParams = {}) =>
    this.request<SocialLoginResponse, GenericErrorResponse>({
      path: '/auth/social/login',
      method: 'POST',
      body,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });


  /**
   * No description
   *
   * @tags Auth
   * @name basicSignIn
   * @request POST:/login
   * @response `200` `LoginResponse` Success
   */
  basicSignIn = (
    body: LoginPayload,
    params: RequestParams = {},
  ) =>
    this.request<LoginResponse, GenericErrorResponse>({
      path: '/login',
      method: 'POST',
      body,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  signUpWithEmail = (data: AccountSignupPayload, params: RequestParams = {}) => this.request<LoginResponse, GenericErrorResponse>({
      path: '/sign-up',
      method: 'POST',
      body: {...data, create_team: false},
      format: 'json',
      type: ContentType.Json,
      ...params,
    });
  
  updateUser = (userId: string, data: Partial<AccountSignupPayload>, params: RequestParams = {}) => this.request<UserResponse, GenericErrorResponse>({
    path: `/users/${userId}`,
    method: 'PATCH',
    body: data,
    format: 'json',
    type: ContentType.Json,
    secure: true,
    ...params,
  });

  authSessionStatus = (authSessionId: string, params: RequestParams = {}) => this.request<SocialLoginResponse, GenericErrorResponse>({
    path: `/auth/social/session/${authSessionId}`,
    method: 'GET',
    format: 'json',
    ...params,
  });

  authSessionAuthorize = (authSessionId: string, code: string, params: RequestParams = {}) => this.request<LoginResponse, GenericErrorResponse>({
    path: `/auth/social/session/${authSessionId}/authorize?code=${code}`,
    method: 'POST',
    format: 'json',
    ...params,
  });

  forgotPassword = (email: string, params: RequestParams = {}) => this.request<ApiResponse, GenericErrorResponse>({
    path: `/users/forgot-password`,
    method: 'POST',
    body: { email },
    type: ContentType.Json,
    format: 'json',
    ...params,
  });

  resetPassword = (email: string, password: string, password_confirmation: string, token: string, params: RequestParams = {}) => this.request<ApiResponse, GenericErrorResponse>({
    path: `/users/reset-password`,
    method: 'POST',
    body: { email, password, password_confirmation, token },
    type: ContentType.Json,
    format: 'json',
    ...params,
  });

  authService = (teamId: string, service: string) => this.request<LoginResponse, GenericErrorResponse>({
    path: `/teams/${teamId}/services/${service}/authenticate`,
    method: 'POST',
    type: ContentType.Json,
    secure: true,
    format: 'json',
  });
}